// const API_BASE_URL = 'http://127.0.0.1:5000'; // For testing with local API build
const API_BASE_URL = 'https://soundoff-backend.onrender.com';  //For production build

export default API_BASE_URL;